import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import type { OwnedStagesSummary } from '@recruitai/shared';
import { pipelineApi } from '@/lib/pipeline-api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Users } from 'lucide-react';

export function StageOwnerDashboard() {
  const navigate = useNavigate();
  const [stages, setStages] = useState<OwnedStagesSummary[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    pipelineApi.getOwnedStages()
      .then(setStages)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-sm text-muted-foreground">Carregando...</p>;
  if (stages.length === 0) return null;

  // Group by job
  const byJob = stages.reduce<Record<string, OwnedStagesSummary[]>>((acc, s) => {
    (acc[s.jobId] ??= []).push(s);
    return acc;
  }, {});

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5" /> Minhas Etapas
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {Object.entries(byJob).map(([jobId, jobStages]) => (
          <div key={jobId} className="border rounded-md p-3">
            <button
              className="text-sm font-medium hover:underline text-left"
              onClick={() => navigate(`/jobs/${jobId}/candidates`)}
            >
              {jobStages[0].jobTitle}
            </button>
            <div className="flex flex-wrap gap-2 mt-2">
              {jobStages.map(s => (
                <Badge key={s.stageId} variant="secondary" className="text-xs">
                  {s.stageName} · {s.contextualRole} · {s.candidateCount} candidato{s.candidateCount !== 1 ? 's' : ''}
                </Badge>
              ))}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
